export { default } from './LegalDetails'
